module.exports = __webpack_public_path__ + "static/casual-fridays-2-575bef3e175d3c70aaaa9619716006d5.jpg";